import Box from "@mui/material/Box";
import { type LinkProps as MUILinkProps } from "@mui/material/Link";
import { Icons } from "@repo/ui";
import { type GatsbyLinkProps } from "gatsby";
import { Link } from "gatsby-theme-material-ui";
import { type FC, type PropsWithChildren } from "react";

type GatsbyThemeMUILinkProps = GatsbyLinkProps<unknown> & MUILinkProps;

export type InternalLinkProps = GatsbyThemeMUILinkProps;

const InternalLink: FC<PropsWithChildren<InternalLinkProps>> = ({ children, ...rest }) => {
    return (
        <Link underline="none" {...rest}>
            {children}
        </Link>
    );
};
export default InternalLink;

export const InternalArrowLink: FC<InternalLinkProps> = ({ children, ...rest }) => (
    <Link underline="none" {...rest}>
        <Box component="span" sx={{ verticalAlign: "middle" }}>
            {children}
        </Box>
        <Box component="span" sx={{ whiteSpace: "nowrap" }}>
            &nbsp;
            <Icons.Arrow
                sx={{
                    width: "1.6rem",
                    height: "1.6rem",
                    ml: 2,
                }}
            />
        </Box>
    </Link>
);

export const BackLink: FC<Omit<InternalLinkProps, "children">> = ({ sx, ...rest }) => (
    <Link sx={{ display: "inline-block", width: "fit-content", ...sx }} underline="none" {...rest}>
        <Box component="span" sx={{ whiteSpace: "nowrap" }}>
            <Icons.Back
                sx={{
                    width: "1.6rem",
                    height: "1.6rem",
                    mr: 2,
                }}
            />
            &nbsp;
        </Box>
        <Box component="span" sx={{ verticalAlign: "middle" }}>
            Zpět
        </Box>
    </Link>
);
